export const pluralize = (count: number, noun: string, suffix = "s"): string =>
  `${count} ${noun}${count !== 1 ? suffix : ""}`;

export const joinStringByComma = (allergens: string[]): string => {
  return allergens.join(", ") + ".";
};
